import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

export const helpers = createMultiStyleConfigHelpers([
  'container',
  'description',
  'form',
  'destination',
  'directionColumn',
  'directionRow',
  'spinner',
  'submitBtn',
])

export const SearchExperienceForm = helpers.defineMultiStyleConfig({
  baseStyle: {
    form: {
      display: 'flex',
      flexDirection: 'column',
      width: 'full',
    },
    directionRow: {
      flexDirection: {
        base: 'unset',
        md: 'row',
      },

      '> *:nth-child(1), > *:nth-child(3)': {
        flex: {
          base: 'unset',
          md: 1,
        },
      },

      '> *:nth-child(2)': {
        flex: {
          base: 'unset',
          md: 2,
        },
      },
    },
    directionColumn: {
      flexDirection: 'column',
    },
    submitBtn: {
      marginTop: 'auto',
      maxH: '48px',
      height: '100%',
    },
  },
})
